import React, { createContext, useContext, useState } from 'react';
import Api from '../utils/Api'; 
import { useAuth } from '../context/AuthContext';
import { useError } from '../context/ErrorContext';

const ForgotPasswordContext = createContext();

export const useForgotPassword = () => {
  const context = useContext(ForgotPasswordContext);
  if (!context) {
    throw new Error('useForgotPassword must be used within a ForgotPasswordProvider');
  }
  return context;
};
 
export const ForgotPasswordProvider = ({ children }) => {
 
  const { user, getToken } = useAuth();
  const [api, setApi] = useState(null);
  const { handleApiError, formErrors, clearErrors } = useError();

    // Initialize API with token getter
    React.useEffect(() => {
    setApi(Api(() => getToken()));
    }, [user, getToken]);


  const forgotPassword = async (data) => {
    clearErrors();
    const response =  await api.call('password/email', 'POST', data, true);
    
    if(response.status === 200){
      return {'status':response.status};
    }else{

      if(response.error.status === 422){
        return {'status':response.error.status,'errors':response.error.validationErrors};
        
      }else{
        return handleApiError(response.error, {
          showAlert: false,
          redirectOn401: true,
          customMessage: 'Failed to forgot password'
        });
      }
      
    }
     
  };

  return (
    <ForgotPasswordContext.Provider value={{ forgotPassword, formErrors }}>
      {children}
    </ForgotPasswordContext.Provider>
  );
}; 